import NextImage from "next/image";
import { SliderCard as SlideCardModel, ComponentProps } from "@/types";
import { Text } from "@/components/ui/text";
import { Video } from "@/components/util/video";
import { getMediaType } from "@/util/media";
import { slideCardVariants } from "./slider.variants";

export type SlideCardProps = ComponentProps<SlideCardModel>;

export const SlideCard = ({ data }: SlideCardProps) => {
  const { title, legend, description, media } = data;
  const styles = slideCardVariants();
  const isVideo = !!media && getMediaType(media?.url) === "video";

  return (
    <article className={styles.base()}>
      <div className={styles.card({ className: "z-20" })}>
        <div className={styles.caption()}>
          <Text
            tag="h2"
            size="displaySmall"
            className={styles.title()}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {(legend || description) && (
            <div className={styles.captionContent()}>
              {!!legend && (
                <Text tag="h4" size="titleLarge" className={styles.legend()}>
                  {legend}
                </Text>
              )}
              {!!description && (
                <Text tag="p" size="titleSmall" className={styles.description()}>
                  {description}
                </Text>
              )}
            </div>
          )}
        </div>
      </div>
      <div
        className={styles.card({
          className: "absolute mobile:inset-0 z-10 md:relative pb-0",
        })}
      >
        {isVideo && (
          <Video
            className={styles.media()}
            containerClassName={styles.mediaWrapper()}
            src={media?.url || ""}
            mime={media?.mime || ""}
            autoPlay
            muted
            loop
            playsInline
          />
        )}
        {!isVideo && (
          <NextImage
            className={styles.image()}
            src={media.url}
            alt={media.alternativeText || ""}
            fill
            sizes="(max-width: 768px) 100vw, 50vw"
            quality={80}
          />
        )}
      </div>
    </article>
  );
};
